import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiText } from '@shared/ui';

import cls from './TextEventRoleBadge.module.css';

interface TextEventRoleBadgeProps {
    classes?: string;
    isExport?: boolean;
    role: 'subcontractor' | 'employee' | 'customer';
}

export const TextEventRoleBadge = ({ classes, isExport, role }: TextEventRoleBadgeProps) => {
    const { t } = useTranslation();

    const roleMapping = {
        customer: '',
        employee: '',
        subcontractor: t(`FilterByAuthor.AuthorBadge.labelMapping.${role}.tooltip`),
    };

    if (role !== 'subcontractor') return null;
    return (
        <div
            className={cn(cls.TextEventRoleBadge, [classes], {
                [cls.export]: isExport,
            })}
        >
            <UiText variant="caption" tag="span">
                {roleMapping[role]}
            </UiText>
        </div>
    );
};
